import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';
import { useTenantContext } from '@/hooks/useTenantContext';
import { NULL_TENANT_ID } from '@/integrations/supabase/session';

export function ForceLogoutBanner() {
  const { user, signOut } = useAuth();
  const { tenantClaim } = useTenantContext();
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check if user has NULL UUID in their JWT claims
    if (user && tenantClaim === NULL_TENANT_ID) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [user, tenantClaim]);

  if (!show) return null;

  return (
    <Alert variant="destructive" className="m-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Session Update Required</AlertTitle>
      <AlertDescription className="flex items-center justify-between">
        <span>
          Your account has been updated. Please log out and log back in to continue using the application.
        </span>
        <Button 
          variant="outline" 
          size="sm" 
          onClick={() => signOut()}
          className="ml-4"
        >
          Log Out Now
        </Button>
      </AlertDescription>
    </Alert>
  );
}
